module.exports = __webpack_public_path__ + "static/img/route_recording_enable.7fd08388.svg";